import React, { createContext, useContext, useEffect, useMemo } from 'react';
import {
  useFormMethods,
  useFormWatch,
} from '../../../../../helpers/formManager';

const Context = createContext();

export const DisabledIntervalsProvider = ({ children, intervalsName }) => {
  const intervals = useFormWatch({ name: intervalsName });

  const { trigger, getFieldState, clearErrors } = useFormMethods();

  const disabledIntervals = useMemo(() => {
    const result = new Set();

    if (intervals?.length) {
      intervals.forEach(({ intervalId, active }) => {
        if (!active) {
          result.add(intervalId);
        }
      });
    }

    return result;
  }, [intervals]);

  const intervalSize = intervals?.length ?? 0;
  const disabledIntervalsSize = disabledIntervals.size;

  const hasValidateError =
    getFieldState(intervalsName).error?.root?.type === 'validate';

  useEffect(() => {
    if (intervalSize > 0 && disabledIntervalsSize === intervalSize) {
      trigger(intervalsName);
    } else if (hasValidateError) {
      clearErrors(intervalsName);
    }
  }, [
    intervalSize,
    disabledIntervalsSize,
    trigger,
    intervalsName,
    hasValidateError,
    clearErrors,
  ]);

  return (
    <Context.Provider value={disabledIntervals}>{children}</Context.Provider>
  );
};

export const useDisabledIntervals = () => useContext(Context);
